import React from "react";
import { inject, observer } from "mobx-react";
import { BestLabel, BestSelect, Checkbox, DateRangePickerWithLabel, Input } from "best-common-react";

function InvestigationsFilters(props) {
  const { investigationsStore, commonStore } = props.rootStore;

  return (
    <div className="col">
      <div className="row m-0 mb-3">
        <div className="col-lg-4 col-xl-5 p-0 mt-1 mr-2">
          <BestLabel> Requester First Name</BestLabel>
          <Input
            className="form-control"
            id="requester-first-name"
            value={investigationsStore.requesterFirstName}
            onChange={val => investigationsStore.setRequesterFirstName(val.target.value)}
          />
        </div>
        <div className="col-lg-4 col-xl-5 p-0 mt-1">
          <BestLabel> Requester Last Name</BestLabel>
          <Input
            className="form-control"
            id="requester-last-name"
            value={investigationsStore.requesterLastName}
            onChange={val => investigationsStore.setRequesterLastName(val.target.value)}
          />
        </div>
      </div>
      <div className="row m-0 mb-3">
        <div className="col-lg-4 col-xl-5 p-0 mt-1 mr-2">
          <BestLabel>Recipient First Name</BestLabel>
          <Input
            value={investigationsStore.recipientFirstName}
            onChange={val => investigationsStore.setRecipientFirstName(val.target.value)}
          />
        </div>
        <div className="col-lg-4 col-xl-5 p-0 mt-1">
          <BestLabel>Recipient Last Name</BestLabel>
          <Input
            className="form-control"
            id="recipient-first-name"
            value={investigationsStore.recipientLastName}
            onChange={val => investigationsStore.setRecipientLastName(val.target.value)}
          />
        </div>
      </div>
      <div className="row m-0 mb-3">
        <div className="col-lg-4 col-xl-5 p-0 mt-1 mr-2">
          <BestLabel>Delivery Phone Number</BestLabel>
          <Input
            className="form-control"
            id="delivery-phone-number"
            type="tel"
            value={investigationsStore.deliveryMobilePhone}
            onChange={val => investigationsStore.setDeliveryMobilePhone(val.target.value)}
          />
        </div>
        <div className="col-lg-4 col-xl-5 p-0 mt-1">
          <BestLabel>Delivery E-mail</BestLabel>
          <Input
            className="form-control"
            id="delivery-email"
            type="email"
            value={investigationsStore.deliveryEmail}
            onChange={val => investigationsStore.setDeliveryEmail(val.target.value)}
          />
        </div>
      </div>

      <div className="row m-0 mb-3">
        <div className="col-lg-4 col-xl-5 p-0 mt-1 mr-2">
          <BestLabel>Organization</BestLabel>
          <BestSelect
            clearable
            id="org"
            options={commonStore.orgDropdownList}
            value={investigationsStore.selectedOrg}
            onChange={v => investigationsStore.setSelectedOrg(v)}
          />
        </div>
        <div className="col-lg-4 col-xl-4 p-0 mt-1 mr-2">
          <DateRangePickerWithLabel
            disabled={!investigationsStore.useDateRange}
            value={commonStore.dateRangeFilter}
            onStartChange={commonStore.setDateRangeFilterStart}
            onEndChange={commonStore.setDateRangeFilterEnd}
            onChange={
              // Only use start and end
              () => {}
            }
            label="Request Date"
          />
        </div>
        <div className="col-lg-1 col-xl-1 p-0 mt-1 pl-4">
          <BestLabel>Use Date</BestLabel>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dateRange"
              checked={investigationsStore.useDateRange}
              onChange={v => {
                investigationsStore.setDateRange(!investigationsStore.useDateRange);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default inject("rootStore")(observer(InvestigationsFilters));
